export const COOKIE_EXPIRATION_YEARS = 1;
